import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 22 22"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      "fill-rule": "evenodd",
      d: "M5.494.23a.786.786 0 0 1 1.112 0l9.657 9.657a1.54 1.54 0 0 1 0 2.226L6.606 21.77a.786.786 0 0 1-1.112-1.111L15.154 11l-9.66-9.659a.786.786 0 0 1 0-1.11Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }